import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Factory, PenTool, ShieldCheck, Truck, Package } from 'lucide-react';
import { PageHero } from '../components/PageHero';
import { capabilities } from '../data/capabilities';
import { products } from '../data/products';
import { ProductPlaceholder } from '../components/ProductPlaceholder';
export function CapabilitiesHubPage() {
  const icons = {
    PenTool: PenTool,
    Factory: Factory,
    ShieldCheck: ShieldCheck,
    Truck: Truck
  };
  // Get a few product images to show "Output"
  const sampleProducts = products.slice(0, 4);
  return <>
      <PageHero label="Manufacturing" title="Our Processes" subtitle="Chiltern Global offers a complete concept-to-delivery manufacturing service, supporting public sector clients with research, production, quality assurance, and logistics." data-id="element-351" />

      <section className="bg-white py-24" data-id="element-352">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-353">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20" data-id="element-354">
            {capabilities.map(cap => {
            const Icon = icons[cap.icon as keyof typeof icons] || Factory;
            return <div key={cap.slug} className="bg-white border border-steel-200 p-10 flex flex-col hover:border-cg-orange-600 transition-colors group" data-id="element-355">
                  <div className="w-12 h-12 bg-slate-50 border border-steel-200 rounded-sm flex items-center justify-center mb-6 group-hover:border-cg-orange-600 transition-colors" data-id="element-356">
                    <Icon className="w-6 h-6 text-cg-orange-600" data-id="element-357" />
                  </div>
                  <h2 className="text-2xl font-bold text-navy-900 mb-4" data-id="element-358">
                    {cap.name}
                  </h2>
                  <p className="text-steel-600 mb-8 flex-1 leading-relaxed" data-id="element-359">
                    {cap.shortDescription}
                  </p>
                  <div className="flex items-center justify-between mt-auto pt-6 border-t border-steel-100" data-id="element-360">
                    <span className="text-xs font-bold text-steel-500 uppercase tracking-wider" data-id="element-361">
                      {cap.howItWorks.length} Step Process
                    </span>
                    <Link to={`/capabilities/${cap.slug}`} className="text-cg-orange-600 font-bold uppercase tracking-wider text-sm flex items-center gap-2 hover:gap-3 transition-all" data-id="element-362">
                      View Capability <ArrowRight className="w-4 h-4" data-id="element-363" />
                    </Link>
                  </div>
                </div>;
          })}
          </div>

          {/* Relevant Categories Visuals - Dossier Style */}
          <div className="border-t border-steel-100 pt-20" data-id="element-364">
            <h2 className="text-2xl font-bold text-navy-900 mb-10 flex items-center gap-3" data-id="element-365">
              <Package className="w-6 h-6 text-cg-orange-600" data-id="element-366" /> Manufacturing
              Outputs
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-367">
              {sampleProducts.map(product => <Link key={product.slug} to={`/products/${product.slug}`} className="group relative aspect-square overflow-hidden rounded-sm border border-steel-200" data-id="element-368">
                  <ProductPlaceholder aspectRatio="1/1" className="w-full h-full" data-id="element-369" />
                  <div className="absolute inset-0 bg-navy-900/0 group-hover:bg-navy-900/10 transition-colors flex items-center justify-center" data-id="element-370">
                    <span className="opacity-0 group-hover:opacity-100 transition-opacity text-navy-900 font-bold text-xs uppercase tracking-wider bg-white px-3 py-1 border border-steel-200 shadow-sm" data-id="element-371">
                      View
                    </span>
                  </div>
                </Link>)}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-navy-900 py-20" data-id="element-372">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-373">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-374">
            Discuss a Manufacturing Requirement
          </h2>
          <p className="text-steel-300 max-w-2xl mx-auto mb-10 text-lg" data-id="element-375">
            Whether you need bespoke product development or scalable production
            capacity, our team is ready to support your project.
          </p>
          <Link to="/contact" className="inline-flex items-center justify-center px-10 py-4 bg-cg-orange-600 hover:bg-cg-orange-500 text-white font-bold uppercase tracking-wider rounded-sm transition-colors" data-id="element-376">
            Contact Us
          </Link>
        </div>
      </section>
    </>;
}